<div class="checklist-container">

    <div class="checklist-block">
        <div class="checklist-header">
            <div class="checklist-title">{{ 'bikeshop.workshop.jobcard.checklist.pre_service_checks' | translate }}
            </div>
            <hub-button [icon]="'arrow-up-right'" [style]="'borderless'" [size]="'lg'"
                (buttonClick)="openPreChecklist()"></hub-button>
        </div>
        <div class="checklist-metric">
            <span class="value">{{workshopJobcardCreateService.getCompletedChecklistCount(preServiceChecklist)}}</span>
            <span class="value">/</span>
            <span class="value">{{workshopJobcardCreateService.getChecklistCount(preServiceChecklist)}}</span>
            <span class="text">{{'bikeshop.workshop.jobcard.checklist.complete' | translate }}</span>
        </div>
    </div>

    <div class="checklist-block">
        <div class="checklist-header">
            <div class="checklist-title">{{ 'bikeshop.workshop.jobcard.checklist.checks_all_services' | translate }}
            </div>
        </div>

        <div class="placeholder-text">
            <daz-icon [name]="'lock'" [size]="'20px'" [color]="'#888888'"></daz-icon>
            <div>{{'bikeshop.workshop.jobcard.checklist.after_job_is_scheduled' | translate}}</div>
        </div>
    </div>

    <div class="checklist-block">
        <div class="checklist-header">
            <div class="checklist-title">{{ 'bikeshop.workshop.jobcard.checklist.mandatory_checks' | translate }}
            </div>
        </div>

        <div class="placeholder-text">
            <daz-icon [name]="'lock'" [size]="'20px'" [color]="'#888888'"></daz-icon>
            <div>{{'bikeshop.workshop.jobcard.checklist.after_job_is_scheduled' | translate}}</div>
        </div>
    </div>

</div>